import React from 'react';
import ReactDOM from 'react-dom';
import Context from './Context';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsExports from './config/aws-exports';

// Configure Amplify with Identity Pool credentials
Amplify.configure(awsExports);

const $root = document.getElementById('root')
const cuotitasHost = process.env.REACT_APP_THEME_CUOTITAS_HOST;
const cuotaYaHost = process.env.REACT_APP_THEME_CUOTAYA_HOST;
const demoHost = process.env.REACT_APP_THEME_DEMO_HOST;

switch (window.location.hostname) {
  case cuotitasHost: $root.setAttribute('theme', 'cuotitas'); break
  case cuotaYaHost: $root.setAttribute('theme', 'cuota-ya'); break
  case demoHost: $root.setAttribute('theme', 'demo'); break
  default: $root.setAttribute('theme', 'demo'); break;
}

const params = new URL(document.location).searchParams;

if(params.has('theme') && ['cuotitas', 'cuota-ya', 'demo'].includes(params.get('theme'))) {
  $root.setAttribute('theme', params.get('theme'))
}

ReactDOM.render(
  <React.StrictMode>
    <Context>
      <App />
    </Context>
  </React.StrictMode>,
  $root
);
